// extracted by mini-css-extract-plugin
export default {"loading":"loading-component_loading__cf-Ok","loading_text":"loading-component_loading_text__q9LNM","textShine":"loading-component_textShine__KzdXr"};